export interface CreateEntityModalState {
  description: string;
  existingEntityNames: Set<string>;
  saving: Promise<void>;
  name: string;
  submitAttempted: boolean;
  open: boolean;
  globalAccessType: string;
}

export interface CreateEntityModalAttrs {
  'entity-type': string;
  'is-editing': boolean;
  'initial-description': string;
  'initial-name': string;
  'modal-title': string;
  open: boolean;
  warning: string;
  'project-id': number;
  'show-share-management': boolean;
  'show-global-access-menu': boolean;
  'visibility-controls-message': string;
}

export interface ModalValues {
  name: string;
  description: string;
}

export interface ModalReturn extends ModalValues {
  didSave: boolean;
}

export enum GlobalAccessType {
  OFF = `Just me`,
  VIEWER = `Everyone can view`,
  EDITOR = `Everyone can edit`,
}
